<template>
    <div>
        <div class="bg-cover" style="background-image: url(/images/banner-bg.jpg)">
            <div class="container py-12">
                <h1 class="text-4xl uppercase font-light">{{ title }}</h1>
            </div>
        </div>
        <div class="container">

            <div class="row py-12 items-center">
                <div class="md:col-auto">
                    <svg class="w-56 h-56 mx-auto" viewBox="0 0 220 220">
                        <path
                            d="M58.32 120.29c2.15 1.39 4.59 2.5 6.41 4.25 6.8 6.5 13.39 13.21 20.33 20.11 6.44-6.43 12.65-12.83 19.1-19 1.8-1.72 4.33-2.68 6.52-4l5.08 4.44c-1 2.2-1.56 4.83-3.13 6.51-6.23 6.68-12.91 12.94-19.12 19.64a9.61 9.61 0 00-2.4 6.39c1 15.61 12.73 28.64 29.7 33.63 23.81 7 48.19-3.67 56.24-25 1.79-4.75 2.25-10 3.33-15l11.14-.35c-1.57 23.53-12.21 41.24-34.63 49.46-23.28 8.52-45.12 4.87-63.47-12.77C85.41 181 81.4 171 79.8 160a17 17 0 00-4.21-8.4c-6.24-6.88-13-13.26-19.35-20.07-1.56-1.68-2.15-4.28-3.18-6.45z"
                            fill="#bb3b31"/>
                        <path
                            d="M115.76 126.14l-5.08-4.44c5.83-7.85 11.89-15.52 17.42-23.57 7.76-11.3 14-23.44 16.21-37.15 1.7-10.47 1.37-20.94-7.56-28.43-3.23-2.72-7.79-4-12-5.35-1.31-.41-3.47 1.12-5 2.17-3.22 2.28-6.89 3.78-10 1.15a13.46 13.46 0 01-4.44-8.17c-.36-3.94 2.6-6.9 6.55-7.6 2-.37 4.43.4 6.51 1.12 3.13 1.09 6 3.11 9.19 3.81 14.73 3.23 25.32 15.15 24.89 30.45a86.21 86.21 0 01-4.66 26.2c-6.71 18.98-18.1 35.31-32.03 49.81z"
                            fill="#A5C5E8"/>
                        <path
                            d="M58.32 120.29L53.06 125C36.48 106.35 22 86.32 17.77 61c-2.51-15 1.31-30 14.51-37.49 2.82-1.61 6.11-2.36 9.16-3.56a100.51 100.51 0 0010.1-4.16C55.63 13.6 60 14 62.74 17.42c2.46 3.07 2.34 8.65-.26 11.51-3 3.26-8.51 4.1-11.59.84-3.52-3.71-7-3-10.85-1.59-8.45 3.05-14.1 11.34-14.82 20.62-1.28 16.5 5 30.68 13.43 44 5.98 9.54 13.07 18.36 19.67 27.49zM191.52 152l-11.14.35c-4.9-3.28-10.59-5.8-14.53-10-7.53-8-8.27-18-4.11-27.87s11.93-14.83 22.79-15.68c15.31-1.19 25.42 10.46 27.76 21.39 2.85 13.3-4.95 26-18.48 30.84-.81.28-1.52.63-2.29.97zm-24.73-26.77c.7 10.29 7.18 18.92 19.4 19.45 9.82.43 18.71-8.9 19.2-19.22.44-9.4-9.17-19.21-19-19.4-10.39-.21-19.39 8.59-19.6 19.15z"
                            fill="#A5C5E8"/>
                        <path
                            d="M185.85 111.91c7.9-.07 13.71 5.49 13.73 13.14 0 8-5.71 13.88-13.61 14-7.67.07-13.34-5.69-13.35-13.55 0-8.19 5.2-13.5 13.23-13.59zm.53 19.2c3.74.34 5.31-2.29 5.82-5.66.44-3-3.53-7.2-6.29-6.13-2.44 1-5.35 3.75-5.78 6.14-.58 3.23 1.99 5.78 6.25 5.65z"
                            fill="#A5C5E8"/>
                    </svg>
                </div>
                <div class="mt-8 md-mt-0 md:col space-y-4">
                    <p class="font-semibold">{{ description }}</p>
                    <p>
                        Please take a look at our
                        <span v-for="(category, i) in $page.props.navCategories">
                            <inertia-link
                                :href="`/categories/${category.slug}`"
                                class="font-semibold text-primary underline"
                                v-text="category.name"
                            /><span
                            v-if="$page.props.navCategories.length > i + 1">{{
                                $page.props.navCategories.length === i + 2 ? ' and ' : ', '
                            }}</span>
                         </span>
                        sections to see expert-authored video posts across every area of cardiovascular and thoracic
                        surgery.
                    </p>
                    <p>
                        If you would like more information, please contact us at
                        <a class="text-blue-500 font-semibold underline" href="mailto:info@mmcts.org">info@mmcts.org</a>.
                    </p>
                </div>
            </div>


        </div>
    </div>
</template>

<script>

import Layout from "@app/Shared/Components/Layout";

export default {

    props: {
        status: Number,
    },

    metaInfo() {
        return {
            title: this.title,
        }
    },

    layout: Layout,

    computed: {
        title() {
            return {
                503: 'Service Unavailable',
                500: 'Server Error',
                404: 'Page Not Found',
                403: 'Forbidden',
            }[this.status]
        },
        description() {
            return {
                503: 'Sorry, we are doing some maintenance. Please check back soon.',
                500: 'Whoops, something went wrong on our servers.',
                404: 'Sorry, the page you are looking for could not be found.',
                403: 'Sorry, you are forbidden from accessing this page.',
            }[this.status]
        },
    },
}
</script>
